import { styled, Box } from '@material-ui/core';

export const ImageUploadedPlaceHolderContainer = styled(Box)({
  width: '100%',
  height: '100%',
  display: 'grid',
  gap: '1rem',
  overflowX: 'hidden',
  overflowY: 'auto',
  gridTemplateColumns: 'repeat(3, 1fr)',
  position: 'relative',
});
